class Storage {
  static set(key, cartItems) {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, JSON?.stringify(cartItems));
    }
  }

  static get(key) {
    if (key && typeof window !== 'undefined') {
      const item = localStorage.getItem(key);
      try {
        return JSON.parse(item);
      } catch (error) {
        return item;
      }
    }
    return null;
  }

  static clear(key) {
    // if (typeof window !== 'undefined') {
    //   return localStorage.clear(key);
    // }
    return null;
  }
}

export default Storage;
